import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 4H1v16h21.99L23 4zm-4 14H5V6h14v12z"
}), 'TabletSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TabletSharp.js
// module id = 6691
// module chunks = 2